import { React,  DomeManipulator } from '@lexriver/dome'
import css from './ErrorForForm.m.scss'
import {DomeComponent} from '@lexriver/dome'


interface Attrs{
    //text:string
}

export class ErrorForForm extends DomeComponent<Attrs>{
    protected readonly divContainer:HTMLDivElement = <div class={css.tooltip}></div>
    protected readonly spanErrorMessage:HTMLSpanElement = <span></span>
    protected isVisible:boolean = false

    protected render(){
        return (
            <div class={css.container}>
                {this.children}
            </div>
        )
    }

}